import Vue from 'vue'
import { Context } from '@nuxt/types';

type NuxtFetch = (ctx: Context) => Promise<unknown>;

Vue.config.optionMergeStrategies.fetch = (to: NuxtFetch, from: NuxtFetch) => (ctx: Context) => {
  return Promise.all([
    to && to(ctx),
    from && from(ctx)
  ])
}
